import {
  catalogService,
  inpatientService,
  listExamination,
  medicalExaminationService,
  medicalSuppliesService,
  receiveService,
  residentialNurseService,
  sharedDirectory,
  storeService,
} from "api";
import { Notification } from "components/common";
import { randomId, setItemLocalStorage } from "./common";

export const listTypeBN = [
  {
    value: 0,
    label: "Cấp cứu",
  },
  {
    value: 1,
    label: "Trẻ em dưới 4 tuổi",
  },
  {
    value: 2,
    label: "Người khuyết tật",
  },
  {
    value: 3,
    label: "Người cao tuổi",
  },
  {
    value: 4,
    label: "Phụ nữ có thai",
  },
  {
    value: 5,
    label: "VIP",
  },
];

export const getListLoaiKCB = async () => {
  try {
    const res = await catalogService.getListLoaiKCB();
    const options = await res.map((e) => {
      return { key: randomId(), value: e.id, label: e.tenLoaiKCB };
    });

    localStorage.setItem("loaiKCB", JSON.stringify(options));
  } catch (error) {
    Notification(
      "error",
      "Đã có lỗi xảy ra khi lấy danh sách loại khám chữa bệnh"
    );
  }
};

export const getListKhuKham = async () => {
  try {
    const res = await catalogService.getListKhuKham();
    const options = await res.map((e) => {
      return { value: e.id, label: e.tenKhuKham };
    });

    localStorage.setItem("khuKham", JSON.stringify(options));
  } catch (error) {
    Notification("error", "Đã có lỗi xảy ra khi lấy danh sách khu khám");
  }
};
export const getListTTKCB = async () => {
  try {
    const res = await medicalExaminationService.getListTTPhieuKham({
      page: 1,
      limit: 20,
    });
    const listTTKCB = res?.data || [];
  } catch (error) {}
};
export const getListTTBH = async () => {
  try {
    const res = await catalogService.getListTTBH();

    const options = await res.map((e) => {
      return { value: e.id, label: e.tenTrangThaiBH };
    });

    localStorage.setItem("TTBH", JSON.stringify(options));
  } catch (error) {
    Notification("error", "Đã có lỗi xảy ra khi lấy danh sách trạng thái BH");
  }
};

export const getListTrangThaiPhieu = async () => {
  try {
    const res = await catalogService.getListTrangThaiPhieu();

    const options = await res.map((e) => {
      return { value: e.id, label: e.tenTTPhieuKham };
    });

    localStorage.setItem("TTPhieu", JSON.stringify(options));
    setItemLocalStorage("TTKCB", options);
  } catch (error) {
    Notification(
      "error",
      "Đã có lỗi xảy ra khi lấy danh sách trạng thái phiếu khám"
    );
  }
};

export const getListPhongKham = async () => {
  try {
    const res = await catalogService.getListPhong();

    const optionsDetail =
      (await res.map((e) => {
        return {
          value: e.id,
          label: `${e.tenPhong} (${e.soBenhNhan})`,
        };
      })) || [];
    const options =
      (await res.map((e) => {
        return {
          value: e.id,
          label: e.tenPhong,
        };
      })) || [];
    localStorage.setItem("phongKhamNoPeople", JSON.stringify(options));
    localStorage.setItem(
      "phongKhamYesPeople",
      JSON.stringify(optionsDetail || null)
    );
  } catch (error) {
    Notification("error", "Đã có lỗi xảy ra khi lấy danh sách phòng khám");
  }
};

export const getListTrangThaiPhauThuat = async () => {
  try {
    const res = await residentialNurseService.getListStatusSurgery();

    const options = await res.map((e) => {
      return { value: e.id, label: e.giaTri };
    });
    localStorage.setItem("TTPhauThuat", JSON.stringify(options));
  } catch (error) {
    Notification(
      "error",
      "Đã có lỗi xảy ra khi lấy danh sách trạng thái phẫu thuật"
    );
  }
};

export const getListTrangThaiCSKH = async () => {
  try {
    const res = await catalogService.getListTrangThaiCSKH();

    const options = await res.map((e) => {
      return { value: e.id, label: e.tenTTCSKH };
    });

    localStorage.setItem("TTCSKH", JSON.stringify(options));
  } catch (error) {
    Notification(
      "error",
      "Đã có lỗi xảy ra khi lấy danh sách trạng thái phiếu CSKH"
    );
  }
};

export const getDoiTuong = async () => {
  try {
    const res = await medicalExaminationService.getListObjects();
    const options = await res.data.map((e) => {
      return { value: e.id, label: e.tenDoiTuong };
    });

    localStorage.setItem("doiTuong", JSON.stringify(options));
  } catch (err) {
    Notification("error", "Lỗi xảy ra khi lấy danh mục đối tượng");
  }
};

export const fetchSourcePatient = async () => {
  try {
    const res = await medicalExaminationService.getSourcePatient();
    const options = await res.data.map((e) => {
      return { value: e.id, label: e.tenNguonBenhNhan };
    });

    localStorage.setItem("nguonBN", JSON.stringify(options));
  } catch (err) {
    Notification(
      "error",
      "Lỗi xảy ra khi lấy thông tin danh mục nguồn bênh nhân"
    );
  }
};

export const getListTrangThaiTraThuoc = async () => {
  try {
    const res = await catalogService.getListTrangThaiTraThuoc();

    const options = res.map((e) => {
      return { value: e.id, label: e.tenTTTraThuoc };
    });
    localStorage.setItem("TTTraThuoc", JSON.stringify(options));
  } catch (error) {
    Notification(
      "error",
      "Đã có lỗi xảy ra khi lấy danh sách trạng thái tra thuốc"
    );
  }
};

export const getListProvince = async () => {
  try {
    const res = await sharedDirectory.getListProvince();
    const options = res.data.map((e) => ({
      value: e.id,
      label: e.name,
    }));
    localStorage.setItem("listCommueNew", JSON.stringify(options));
  } catch (error) {
    Notification("error", "Đã có lỗi xảy ra khi lấy danh sách tỉnh");
    return localStorage.setItem("listCommueNew", JSON.stringify([]));
  }
};

export const fetchExamServiceCategory = async () => {
  try {
    let response = await medicalExaminationService.getListExamServiceCategory();
    const options = response.data.map((e) => ({
      value: e.id,
      label: e.tenDichVu,
    }));
    localStorage.setItem("dichVu", JSON.stringify(options));
  } catch (err) {
    Notification("error", "Lỗi xảy ra khi lấy danh mục dịch vụ");
    return localStorage.setItem("dichVu", JSON.stringify([]));
  }
};
export const getListUnitAPI = async () => {
  try {
    const res = await catalogService.getListUnit();
    const listUnit = res?.data;
    const donViTinhOptions = listUnit?.map((unit) => ({
      key: randomId(),
      value: unit.id,
      label: unit.name,
    }));
    localStorage.setItem("donVi", JSON.stringify(donViTinhOptions));
  } catch (error) {
    return localStorage.setItem("donVi", JSON.stringify([]));
  }
};
export const getListQuyCach = async () => {
  try {
    const res = await medicalSuppliesService.getQuyCach();

    const quyCachOptions = res?.map((e) => ({
      key: randomId(),
      value: e.id,
      label: e.name,
    }));
    localStorage.setItem("quyCach", JSON.stringify(quyCachOptions));
  } catch (error) {
    return localStorage.setItem("quyCach", JSON.stringify([]));
  }
};
export const getListHinhThucThanhToan = async () => {
  try {
    const res = await storeService.getListPayments({});
    localStorage.setItem("hinhThucThanhToan", JSON.stringify(res?.data));
    return res;
  } catch (error) {
    localStorage.setItem("hinhThucThanhToan", JSON.stringify([]));
    return [];
  }
};

export const getLitGroup = async () => {
  try {
    let response = await receiveService.getLitGroup();
    console.log("🚀 ~ getLitGroup ~ response:", response);
    // if (response.status == 200) {
    localStorage.setItem("tenDoan", JSON.stringify(response));

    // }
  } catch (err) {
    localStorage.setItem("tenDoan", JSON.stringify([]));
  }
};

export const fetchListDmPPPT = async () => {
  const params = {
    idNhomDichVu: 2,
  };
  try {
    const response = await listExamination.getByIdNDV(params);
    const options = response.data.map((e) => ({
      value: e.id,
      label: e.tenDichVu,
    }));
    // fields.find((e) => e.name === "ppPhauThuat").options = options;
    localStorage.setItem("ppPhauThuat", JSON.stringify(response));
  } catch (err) {
    localStorage.setItem("ppPhauThuat", JSON.stringify([]));
  }
};

export const getListBuongSo = async () => {
  const param = {
    page: 1,
    limit: 1000,
  };
  try {
    // setLoading(true);
    const res = await inpatientService.getListDanhMucPhongBenh(param);
    localStorage.setItem("phong", JSON.stringify(res.data));
  } catch (error) {
    localStorage.setItem("phong", JSON.stringify([]));
  }
};

export const getListDanhMucGiuongBenh = async () => {
  try {
    const params = {
      limit: 10000,
      page: 1,
    };

    const res = await inpatientService.getListDanhMucGiuongBenh(params);
    localStorage.setItem("giuong", JSON.stringify(res.data));
  } catch (error) {
    localStorage.setItem("giuong", JSON.stringify([]));
  }
};
